'use client'
import './index.css';
import React, { useEffect, useRef, useState } from "react";
import PropTypes from 'prop-types';


const Carousel = ({
    items,
    Component,
    cpntProps,
    gap,
    hidden,
    uid,
    className,
    hasDots = true,
    hasArrow = true,
    observersOption = {
        rootMargin: "0px",
        threshold: .5,
        delay: 100
    }, }) => {


    let [selected, setSelected] = useState(0)
    const carouselWidth = useRef(null);

    useEffect(() => {
        let options = observersOption;

        let callback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const ref = entry.target.dataset.col;
                    if (ref != undefined) {
                        const targets = document.querySelectorAll(`.items-dot-${uid}`);
                        Array.from(targets).map(e => {
                            if (e.dataset.dot == ref) {
                                e.firstChild.src = "/svg/dot-active.svg";
                                setSelected(parseInt(e.dataset.dot));
                            } else {
                                e.firstChild.src = "/svg/dot.svg";
                            }
                        });
                    }
                }
            });
        };
        let observer = new IntersectionObserver(callback, options);
        const targets = document.querySelectorAll(`.items-carousel-${uid}`);
        targets.forEach(target => {
            observer.observe(target)
        })
    });

    const prev = () => {
        if (selected > 0) {
            carouselWidth.current.scrollLeft -= carouselWidth.current.clientWidth;
        }

    }

    const next = () => {
        if (selected < items.length - 1) {
            carouselWidth.current.scrollLeft += carouselWidth.current.clientWidth;
        }
    }

    return (
        <React.Fragment>
            <div ref={carouselWidth} className={`${gap} ${hidden} flex snap-x snap-mandatory scroll-smooth no-scrollbar overflow-x-scroll`}>
                {items.map((item, i) => <div key={i} data-col={i} className={`fgrow snap-center snap-always transition duration-300 items-carousel-${uid}`}>
                    <Component index={i} item={item} {...cpntProps} />
                </div>
                )}
            </div>
            {
                hasDots && <div className={`${hidden} flex flex-row gap-2 items-center justify-center mt-8`}>
                     <div className="w-5 mr-5 cursor-pointer hidden md:block" onClick={prev}><img className={`rotate-180 transition duration-500 ${selected === 0 ? 'opacity-50' : 'opacity-100'}`} src="/svg/arrow-right.svg"  loading="lazy"/></div>
                    {items.map((_, i) => <div key={i} className={`items-dot-${uid}`} data-dot={i}>
                        <img src="/svg/dot.svg" alt="point" className="w-2.5 h-2.5" loading="lazy"/>
                    </div>)}
                    <div className="w-5 ml-5 cursor-pointer hidden md:block" onClick={next}><img className={`transition duration-500  ${selected === items.length - 1 ? 'opacity-50' : 'opacity-100'}`} src="/svg/arrow-right.svg"  loading="lazy"/></div>
                </div>
            }
        </React.Fragment>
    );
}

export default Carousel;

Carousel.prototype = {
    items: PropTypes.array,
    hasDots: PropTypes.bool,
    gap: PropTypes.string,
    children: PropTypes.element.isRequired,
    className: PropTypes.string,
}
